import * as React from "react";
import type { ToastActionElement, ToastProps } from "@/components/ui/toast";
import i18n from "@/locales";

// 继承原始配置，但优化参数
const TOAST_LIMIT = 1; // 增加显示数量限制
const TOAST_REMOVE_DELAY = 3000; // 缩短移除延迟

type ToasterToast = ToastProps & {
  id: string;
  title?: React.ReactNode;
  description?: React.ReactNode;
  action?: ToastActionElement;
};

// 状态码映射配置
const STATUS_CODE_MESSAGES = {
  // HTTP 状态码
  // 400: {
  //   type: "error" as const,
  //   title: "Bad Request",
  //   description: "Please check your input and try again",
  // },
  // 401: {
  //   type: "error" as const,
  //   title: "Unauthorized",
  //   description: "Please sign in to continue",
  // },
  // 403: {
  //   type: "error" as const,
  //   title: "Access Denied",
  //   description: "You don't have permission for this action",
  // },
  // 404: {
  //   type: "error" as const,
  //   title: "Not Found",
  //   description: "The requested content was not found",
  // },
  // 408: {
  //   type: "error" as const,
  //   title: "Request Timeout",
  //   description: "Request timed out, please try again",
  // },
  // 429: {
  //   type: "error" as const,
  //   title: "Too Many Requests",
  //   description: "Please wait a moment before trying again",
  // },
  // 500: {
  //   type: "error" as const,
  //   title: "Server Error",
  //   description: "Something went wrong, please try again later",
  // },
  // 502: {
  //   type: "error" as const,
  //   title: "Service Unavailable",
  //   description: "Service temporarily unavailable",
  // },
  // 503: {
  //   type: "error" as const,
  //   title: "Service Unavailable",
  //   description: "Service under maintenance",
  // },
  // 504: {
  //   type: "error" as const,
  //   title: "Gateway Timeout",
  //   description: "Server response timeout",
  // },
  // // 网络连接错误
  // 0: {
  //   type: "error" as const,
  //   title: "Connection Failed",
  //   description: "Please check your internet connection",
  // },
  // // 现有的业务状态码保持不变
  // 200: {
  //   type: "success" as const,
  //   title: "Success",
  //   description: "Operation completed successfully",
  // },
  // 1001: {
  //   type: "error" as const,
  //   title: "Invalid Input",
  //   description: "Please check your input",
  // },
  1002: {
    type: "default" as const,
    title: "Missing token",
    description: "Missing token~~",
  },
  // 1003: {
  //   type: "error" as const,
  //   title: "Access Restricted",
  //   description: "Insufficient permissions",
  // },
  // 1004: {
  //   type: "error" as const,
  //   title: "Content Not Found",
  //   description: "The requested content is not available",
  // },
  // 1005: {
  //   type: "error" as const,
  //   title: "Already Exists",
  //   description: "This item already exists",
  // },
  // 1006: {
  //   type: "error" as const,
  //   title: "Sign In Failed",
  //   description: "Invalid email or password",
  // },
  // 1007: {
  //   type: "error" as const,
  //   title: "Invalid Code",
  //   description: "Verification code is incorrect or expired",
  // },
  // 1008: {
  //   type: "error" as const,
  //   title: "Authorization Failed",
  //   description: "Third-party authorization failed",
  // },
  // 1009: {
  //   type: "error" as const,
  //   title: "Operation Failed",
  //   description: "Please try again later",
  // },
  // 1010: {
  //   type: "error" as const,
  //   title: "System Error",
  //   description: "System error, please contact support",
  // },
  // 1011: {
  //   type: "error" as const,
  //   title: "Slow Down",
  //   description: "Too many requests, please wait",
  // },
  // 1012: {
  //   type: "error" as const,
  //   title: "Invalid Format",
  //   description: "Data format is incorrect",
  // },
  // 1013: {
  //   type: "error" as const,
  //   title: "Upload Failed",
  //   description: "File upload failed, please try again",
  // },
  // 1014: {
  //   type: "error" as const,
  //   title: "Session Expired",
  //   description: "Please sign in again",
  // },
  // 1015: {
  //   type: "error" as const,
  //   title: "Account Suspended",
  //   description: "Account suspended, contact support",
  // },
  1022: {
    type: "default" as const,
    title: "Feature",
    description: i18n.t("status_code_messages.1022"),
  },
  1023: {
    type: "default" as const,
    title: "Balance",
    description: i18n.t("status_code_messages.1023"),
  },
  1028: {
    type: "error" as const,
    title: "Upload Failed",
    description: i18n.t("status_code_messages.1028"),
  },
  1029: {
    type: "error" as const,
    title: "Product Error",
    description: i18n.t("status_code_messages.1029"),
  },
  1030: {
    type: "error" as const,
    title: "Product Error",
    description: i18n.t("status_code_messages.1030"),
  },
  1031: {
    type: "error" as const,
    title: "Product Error",
    description: i18n.t("status_code_messages.1031"),
  },
  1032: {
    type: "error" as const,
    title: "User Error",
    description: i18n.t("status_code_messages.1032"),
  },
  1033: {
    type: "error" as const,
    title: "User Error",
    description: i18n.t("status_code_messages.1033"),
  },
  1034: {
    type: "error" as const,
    title: "User Error",
    description: i18n.t("status_code_messages.1034"),
  },
} as const;

type StatusCode = keyof typeof STATUS_CODE_MESSAGES;

// 继承原始 actionTypes
const actionTypes = {
  ADD_TOAST: "ADD_TOAST",
  UPDATE_TOAST: "UPDATE_TOAST",
  DISMISS_TOAST: "DISMISS_TOAST",
  REMOVE_TOAST: "REMOVE_TOAST",
} as const;

let count = 0;

function genId() {
  count = (count + 1) % Number.MAX_SAFE_INTEGER;
  return count.toString();
}

type ActionType = typeof actionTypes;

type Action =
  | {
    type: ActionType["ADD_TOAST"];
    toast: ToasterToast;
  }
  | {
    type: ActionType["UPDATE_TOAST"];
    toast: Partial<ToasterToast>;
  }
  | {
    type: ActionType["DISMISS_TOAST"];
    toastId?: ToasterToast["id"];
  }
  | {
    type: ActionType["REMOVE_TOAST"];
    toastId?: ToasterToast["id"];
  };

interface State {
  toasts: ToasterToast[];
}

const toastTimeouts = new Map<string, ReturnType<typeof setTimeout>>();

const addToRemoveQueue = (toastId: string) => {
  if (toastTimeouts.has(toastId)) {
    return;
  }

  const timeout = setTimeout(() => {
    toastTimeouts.delete(toastId);
    dispatch({
      type: "REMOVE_TOAST",
      toastId: toastId,
    });
  }, TOAST_REMOVE_DELAY);

  toastTimeouts.set(toastId, timeout);
};

// 继承原始 reducer 逻辑
export const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "ADD_TOAST":
      return {
        ...state,
        toasts: [...state.toasts, action.toast].slice(-TOAST_LIMIT),
      };

    case "UPDATE_TOAST":
      return {
        ...state,
        toasts: state.toasts.map((t) =>
          t.id === action.toast.id ? { ...t, ...action.toast } : t
        ),
      };

    case "DISMISS_TOAST": {
      const { toastId } = action;

      if (toastId) {
        addToRemoveQueue(toastId);
      } else {
        state.toasts.forEach((toast) => {
          addToRemoveQueue(toast.id);
        });
      }

      return {
        ...state,
        toasts: state.toasts.map((t) =>
          t.id === toastId || toastId === undefined
            ? {
              ...t,
              open: false,
            }
            : t
        ),
      };
    }
    case "REMOVE_TOAST":
      if (action.toastId === undefined) {
        return {
          ...state,
          toasts: [],
        };
      }
      return {
        ...state,
        toasts: state.toasts.filter((t) => t.id !== action.toastId),
      };
  }
};

const listeners: Array<(state: State) => void> = [];

let memoryState: State = { toasts: [] };

function dispatch(action: Action) {
  memoryState = reducer(memoryState, action);
  listeners.forEach((listener) => {
    listener(memoryState);
  });
}

type Toast = Omit<ToasterToast, "id">;

// 继承原始 toast 函数
function toast({ ...props }: Toast) {
  const id = genId();

  const update = (props: ToasterToast) =>
    dispatch({
      type: "UPDATE_TOAST",
      toast: { ...props, id },
    });
  const dismiss = () => dispatch({ type: "DISMISS_TOAST", toastId: id });

  dispatch({
    type: "ADD_TOAST",
    toast: {
      ...props,
      id,
      open: true,
      onOpenChange: (open) => {
        if (!open) dismiss();
      },
    },
  });

  return {
    id: id,
    dismiss,
    update,
  };
}

// 扩展：完整的便捷方法
type ToastOptions = {
  title?: string;
  description?: string;
  action?: ToastActionElement;
};

const toastMethods = {
  // 错误提示
  error: (options: ToastOptions) =>
    toast({ ...options, variant: "destructive" }),
  // 默认提示（保持与原始兼容）
  default: (options: ToastOptions) =>
    toast({ ...options, variant: "default" }),
};

/**
 * 根据状态码显示对应的Toast提示
 * @param input 包含status和message的对象或状态码
 * @param customMessage 自定义消息（可选，向后兼容）
 */
function showToastByCode(
  input: StatusCode | { code: number; message: string },
  customMessage?: { title?: string; description?: string }
) {
  console.log("showToastByCode", input, customMessage);
  // 如果输入是对象，处理新的格式
  if (typeof input === 'object' && 'code' in input && 'message' in input) {
    const { code, message } = input;
    const config = STATUS_CODE_MESSAGES[code as StatusCode];

    if (!config) {
      // 状态码不存在，直接显示message
      toastMethods.error({
        title: "Error",
        description: message,
      });
      return;
    }

    const { type, description } = config;
    toastMethods[type]({
      title: "Error", // 可以根据需要调整
      description: code === 1002 ? message : (description || message),
    });
    return;
  }

  // 保持原有逻辑，向后兼容
  const code = input as StatusCode;
  const config = STATUS_CODE_MESSAGES[code];

  if (!config) {
    // 未知状态码，显示默认错误提示
    toastMethods.error({
      title: "Unknown Error",
      description: `${code}`,
    });
    return;
  }

  const { type, title, description } = config;

  // 使用自定义消息或默认消息
  const finalTitle = customMessage?.title || title;
  const finalDescription = customMessage?.description || description;

  toastMethods[type]({
    title: finalTitle,
    description: finalDescription,
  });
}

// 扩展的 useToast Hook
function useToast() {
  const [state, setState] = React.useState<State>(memoryState);

  React.useEffect(() => {
    listeners.push(setState);
    return () => {
      const index = listeners.indexOf(setState);
      if (index > -1) {
        listeners.splice(index, 1);
      }
    };
  }, [state]);

  return {
    ...state,
    // 保持与原始 use-toast.ts 的兼容性
    toast: Object.assign(toast, toastMethods),
    // 扩展功能
    showToastByCode,
    // 便捷方法直接暴露
    error: toastMethods.error,
    dismiss: (toastId?: string) => dispatch({ type: "DISMISS_TOAST", toastId }),
  };
}

export {
  useToast,
  toast,
  showToastByCode,
  type StatusCode,
  type ToastOptions,
};
